import http from "../../services/http";

const getAllActiveSectorsApi = async () => {
  return await http("get", `v1/setores/listar_ativos`);
};

export { getAllActiveSectorsApi };
